import type { FeatureManifest } from '../registry.js';
import { waiting } from './queue.js';

/**
 * SO-05 share links in the app. The apps claim `/s/:id` on the link host, and the web build
 * gets it through the SPA fallback. GET /v1/l/:id says what the link is, a card names the
 * friend and the challenge, and the feature that owns the mode plays it: restock help →
 * restock, daily → daily. Beat my score is played here.
 */
export default {
  id: 'links',
  online: true,
  provides: ['sharedLink'],
  links: ['shareLink', 'beat'],
  art: ['rare'],
  // last: the session's own cards come first, so "Play" starts the round with nothing in between
  mapOrder: 90,
  mapDue: () => waiting.length > 0,
  load: () => import('./index.js'),
} satisfies FeatureManifest;
